// 戻る制御
const history = window.history
const initState = history.state

switch (initState && initState.canGoBack) {
  case null:
  case undefined: {
    // 初回アクセス
    const stateCopy = initState === null ? {} : Object.assign({}, initState)
    stateCopy.canGoBack = false
    history.replaceState(stateCopy, '')
  }
}
